import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { useGetHistoryDisabledState } from 'app/modules/wallforming/components/placement-history/hooks/useGetHistoryDisabledState';
import { HistoryDialog } from 'app/modules/wallforming/components/placement-history/types/historyDialog';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const UndoHistory = () => {
    const { t } = useTranslation();
    const disabled = useGetHistoryDisabledState();
    const setHistoryDialog = usePlacementStore((state) => state.setHistoryDialog);

    return (
        <Menu.Item
            disabled={disabled}
            leftSection={<Icon aria-hidden="true" icon="history" />}
            rightSection={<ActionShortcutHint actionId={InputActionId.GeneralUndoHistory} />}
            onClick={() => setHistoryDialog(HistoryDialog.UNDO)}
        >
            {t('undoHistory')}
        </Menu.Item>
    );
};
